<template>
  <Tooltip
    :key="'limpar-filtro-' + temFiltrosAplicados"
    tag="div"
    class="container-limpar-filtros"
    :texto="temFiltrosAplicados ? '' : $i18n('interface.limpar_filtro_disabled_tooltip_text')"
    placement="bottom"
    data-custom-class="custom-maino-tooltip"
  >
    <template #content>
      <button 
        @click="limparFiltro" 
        class="btn-limpar-filtro white-space-now-wrap"
        :disabled="!temFiltrosAplicados"
      >
        {{ $i18n('links.helpers.clean_filter') }}
      </button>
    </template>
  </Tooltip>
</template>
<script>
import Tooltip from '~/src/helpers/ToolTip.vue';
export default {
  emits: ['limparFiltro'],
  components: {
    Tooltip
  },
  computed: {
    temFiltrosAplicados() {
      const filtros = Object.keys(this.$store.state.filtroAplicados).filter(filtro => !['_', 'filtro_aplicado', 'page', 'limpar_filtro'].includes(filtro));
      return filtros.length > 0;
    }
  },
  methods: {
    limparFiltro() {
      this.$emit('limparFiltro');
    }
  }
}
</script>
